export const voidFunc = () => {};
